import {SortDirection} from '@angular/material/sort';
import {CycleListType} from '@core/api/data-access';

export type ICycleQueryRequest = {
	query: string;
	page: number;
	size: number;
};

export const QueryCycleSortMarker = {
	LastUpdate: 'LastUpdate',
	CreateDate: 'CreateDate',
	Creator: 'Creator',
} as const;
export type QueryCycleSortMarker = (typeof QueryCycleSortMarker)[keyof typeof QueryCycleSortMarker];

export type QueryCycleSortBy = {
	sortMarker: QueryCycleSortMarker;
	direction: SortDirection;
};

export enum DateRangeType {
	LastUpdate = 'LastUpdate', // fromDate /	toDate
	CreateDate = 'CreateDate', // fromCreateDate / toCreateDate
}

export type ICycleQuery = {
	listType: CycleListType[]; // the type of lists to include in the query

	page: number; // current page (query - backend)
	size: number; // page size (query - backend)

	query?: string; // search string (query - backend)

	sortBy?: QueryCycleSortBy; // sort by (query - backend)
	sortDesc?: boolean; // sort direction (query - backend) - true: desc, false: asc

	dateRangeType?: DateRangeType; // date range type (query - backend)

	// if dateRangeType is LastUpdate
	fromDate?: Date; // from last updated date (query - backend)
	toDate?: Date;

	// if dateRangeType is CreateDate
	fromCreateDate?: Date; //	from created date (query - backend)
	toCreateDate?: Date; //	to created date (query - backend)
};

export function isICycleQuery(query: object): query is ICycleQuery {
	return 'listType' in query && 'page' in query && 'size' in query;
}
